import Vue from 'vue'
import App from './App.vue'
import './mixin'
import './directives'
import './filters'
import vuetify from "./plugins/vuetify"
import router from "./routes"
import store from './store/index'
import {func} from './functions'
import VueEasyLightbox from 'vue-easy-lightbox'
import vuescroll from 'vuescroll'
import NoResult from "@/components/NoResult.vue"
import ConfirmDialog from "@/components/dialogs/ConfirmDialog.vue"
import Lightbox from "@/components/Lightbox.vue"
import Overlay from "@/components/Overlay.vue"
import VueApexCharts from 'vue-apexcharts'
import fr from "apexcharts/dist/locales/fr.json"
import roleMiddleware from './middleware/roleMiddleware'
import './registerServiceWorker'

Vue.use(VueApexCharts)
window.Apex.chart = {
    fontFamily: "Poppins, sans-serif",
    locales: [fr],
    defaultLocale: 'fr'
}

Vue.component('apexchart', VueApexCharts)
Vue.component('NoResult', NoResult)
Vue.component('ConfirmDialog', ConfirmDialog)
Vue.component('Lightbox', Lightbox)
Vue.component('Overlay', Overlay)

Vue.use(vuescroll);
Vue.prototype.$func = func
Vue.config.productionTip = false
Vue.use(VueEasyLightbox)
Vue.use(roleMiddleware)

new Vue({
    render: h => h(App),
    store,
    router,
    vuetify,
}).$mount('#app')
